// colors
const colors = {
    coral: "#f07177",
    orange: "#efa651",
    gold: "#fbd54f",
    greenyBaby: "#76d655",
    superLightBlue: "#e7f6ff",
    lightBlue: "#b5ecff",
    brightBlue: "#79dafb",
    midBlue: "#2cabe0",
    darkBlue: "#1389bb",
    darkHoverBlue: "#006b99",
    white: "#ffffff",
    grayBackground: "#f3f3f3",
    superLightGray: "#f0f0f0",
    lightGray: "#dcdcdc",
    inactiveGray: "#adadad",
    darkHoverGray: "#424242",
    darkGray: "#777777",
    grayBlack: "#202020",
    black: "#000000",
}

export default colors